

let regex = /^(.*)(\d{3}) ?(\d{3}) ?(\d{3})$/
export default function getFormattedPhone(phone) {
    let formatted = phone.replace(regex, '$1 $2 $3 $4')

    if (formatted.startsWith(' ')) {
        return formatted.replace(' ', '')
    }
    return formatted
}